@if (this.showTable) {
  <snelstart-ui-table [config]="tableConfig" loadType="Pagination" style="min-height: 210px;">
    <snelstart-ui-table-col name="dateCreation" displayName="Datum" width="150px">
      <snelstart-ui-table-col-data>
        <ng-template let-dateCreation>
          @if(dateCreation === undefined) {
            <ng-container>
              <a>niet bekend</a>
            </ng-container>
          } @else {
            {{dateCreation | date: 'dd-MM-yyyy'}}
          }
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col >
<!--    <snelstart-ui-table-col name="dateDeadline" displayName="Deadline" columnType="date" width="150px">-->
<!--      <snelstart-ui-table-col-data>-->
<!--        <ng-template let-dateDeadline>-->
<!--          {{dateDeadline | date: 'dd-MM-yyyy'}}-->
<!--        </ng-template>-->
<!--      </snelstart-ui-table-col-data>-->
<!--    </snelstart-ui-table-col>-->
    <snelstart-ui-table-col name="clientName" displayName="Klant" [showFilter]="false" [showSort]="false" width="250px">
    </snelstart-ui-table-col>
    <snelstart-ui-table-col name="title" displayName="Omschrijving" [showFilter]="false" [showSort]="false" width="400px">
    </snelstart-ui-table-col>
    <snelstart-ui-table-col displayName="Naar dossier" name="checked" width="200px">
      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          <a (click)="goToClientDossier(record, $event)">
            <ng-container>
              <snelstart-ui-badge [icon]="'arrow-up-right-from-square'" [small]="false" [type]="'default'"
                                  label="Open dossier"></snelstart-ui-badge>
            </ng-container>
          </a>
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
      <snelstart-ui-table-col displayName="Afgerond" name="checked" width="200px">
          <snelstart-ui-table-col-data>
              <ng-template let-record="record">
                  <a (click)="saveForm(record, $event)">
                      <ng-container>
                          <snelstart-ui-badge [icon]="'check'" [small]="false" [type]="'warning'"
                                              label="Markeer als gedaan"></snelstart-ui-badge>
                      </ng-container>
                  </a>
              </ng-template>
          </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>
  </snelstart-ui-table>
}

<snelstart-venture-fiscaal-domain-logic-workflow [(dialogVisible)]="this.dialogVisible"
                                                 [id]="this.client.sstRelationId"
                                                 [type]=this.type>
</snelstart-venture-fiscaal-domain-logic-workflow>
